var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProducerActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5667 7.39987V13.0998C17.5667 14.0332 17.0667 14.8999 16.2584 15.3749L11.3084 18.2332C10.5 18.6999 9.50005 18.6999 8.68338 18.2332L3.73338 15.3749C2.92505 14.9082 2.42505 14.0415 2.42505 13.0998V7.39987C2.42505 6.46653 2.92505 5.59983 3.73338 5.12483L8.68338 2.2665C9.49172 1.79984 10.4917 1.79984 11.3084 2.2665L16.2584 5.12483C17.0667 5.59983 17.5667 6.4582 17.5667 7.39987Z",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.41651C11.0724 9.41651 11.9417 8.54719 11.9417 7.47483C11.9417 6.40248 11.0724 5.5332 10 5.5332C8.92766 5.5332 8.05835 6.40248 8.05835 7.47483C8.05835 8.54719 8.92766 9.41651 10 9.41651Z",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.1331C13.3333 12.6331 11.8416 11.4165 9.99996 11.4165C8.15829 11.4165 6.66663 12.6331 6.66663 14.1331",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducerActive);
export default __webpack_public_path__ + "static/media/producer-active.f5bc0cb201b437e8221ca785c181a96c.svg";
export { ForwardRef as ReactComponent };